import { css } from '@emotion/react'
import { Button, Cell, Grid, Heading, Icon, Link, Text, VFlow } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import image from 'images/error.webp'

interface ErrorViewProps {
  resetError(): void
}

export function ErrorView(props: Readonly<ErrorViewProps>) {
  const { resetError } = props

  const handleVoltarClick = () => {
    window.history.back()
    resetError()
  }

  return (
    <PageContent>
      <Grid style={styles.container} alignItems='center' justifyContent='space-around'>
        <Cell>
          <VFlow>
            <VFlow vSpacing={0.5}>
              <Heading level={1}>Ocorreu um erro inesperado.</Heading>
              <p>Entre em contato com o administrador do sistema para reportar o erro.</p>
            </VFlow>

            <p>
              <Button kind='primary' onClick={handleVoltarClick}>
                <Icon icon='arrowLeft' style={styles.arrowLeft} />
                <Text color='inherit'>Retornar à página anterior</Text>
              </Button>
            </p>

            <p>
              <Link href='/'>Acessar página inicial</Link>
            </p>
          </VFlow>
        </Cell>
        <Cell>
          <img
            src={image}
            alt='Duas pessoas olhando para uma tela de computador com um sinal de aviso, representando que ocorreu um erro'
            width={532}
          />
        </Cell>
      </Grid>
    </PageContent>
  )
}

const styles = {
  container: css`
    height: 100vh;
  `,
  arrowLeft: css`
    margin-right: 0.25rem;
  `,
}
